/* ============================================================
   Ulmo Honey — site effects (Oct 2026)
   1 stat counters · 2 header shadow · 3 reading line · 4 origin film
   5 add-to-cart moment, with the "add a 2nd jar for free expedited shipping" offer
   Settings (page type, shipping rule, country, ULMO+ member, film script) come from
   snippets/redesign-fx.liquid as window.UlmoFX.
   ============================================================ */
(function () {
  'use strict';

  var FX = window.UlmoFX || {};
  var d = document;
  var root = d.documentElement;
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* Clean jar photos (front, back, side). Only these fly to the bag on add to cart;
     charts, infographics and lifestyle shots never do. ulmo-honey-12oz-jar-front / -back
     are the SEO renames of the front and back photos (Oct 22, 2026); the old names stay
     so older uploads still match. */
  var JAR_RE = /(ulmo-honey-12oz-jar-(front|back)|main_product_pic_front|product_pic_back|new_prodocut_pic_side_light_cone|jar_front_new_website|jar_back_new_website)/i;
  /* The flight itself uses clean transparent PNGs of the jar (Oct 22, 2026). The gallery
     photos are white-background JPGs, which flew with a white square around the jar.
     The side photo is already a transparent PNG, so it flies as is. */
  var FLY_PNG = {
    front: 'https://cdn.shopify.com/s/files/1/0649/2979/2195/files/jar_front_new_website.png?width=480',
    back: 'https://cdn.shopify.com/s/files/1/0649/2979/2195/files/jar_back_new_website.png?width=480'
  };
  function flySrc(img) {
    var s = img.currentSrc || img.src;
    if (/jar-back|jar_back|product_pic_back/i.test(s)) return FLY_PNG.back;
    if (/\.png(\?|$)/i.test(s)) return s;
    return FLY_PNG.front;
  }

  function ready(fn) {
    if (d.readyState !== 'loading') fn(); else d.addEventListener('DOMContentLoaded', fn);
  }
  function inView(el, min) {
    var r = el.getBoundingClientRect();
    if (r.width < 2 || r.height < 2) return false;
    var vis = Math.min(r.bottom, innerHeight) - Math.max(r.top, 0);
    return vis > r.height * (min || 0.3);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------------- 1. Stat counters ---------------- */
  function setupCounters() {
    if (RM || !('IntersectionObserver' in window)) return;
    d.querySelectorAll('.u-bento-grid .u-bento-stat-value').forEach(function (el) {
      var tn = el.firstChild;
      if (!tn || tn.nodeType !== 3) return;
      var raw = tn.nodeValue.trim(), target = parseFloat(raw);
      if (!(target > 0)) return;
      if (inView(el, 0.01)) return; /* already on screen: leave it alone */
      var real = d.createElement('span');
      real.className = 'fx-count__real';
      real.textContent = raw;
      var anim = d.createElement('span');
      anim.className = 'fx-count__anim';
      anim.setAttribute('aria-hidden', 'true');
      var box = d.createElement('span');
      box.className = 'fx-count';
      box.appendChild(real);
      box.appendChild(anim);
      el.replaceChild(box, tn);
      /* Whole numbers count in whole steps, so "2×" goes 0, 1, 2 (Tony, Oct 20); a number
         written with decimals keeps them. Small numbers step evenly, big ones (97%) ease out. */
      var dec = (raw.split('.')[1] || '').length;
      var stepped = dec === 0 && target < 10;
      anim.textContent = (0).toFixed(dec);
      box.classList.add('is-counting');
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        io.disconnect();
        var t0 = performance.now(), dur = stepped ? 1200 : 1600;
        var step = function (t) {
          /* The first frame's time can be a hair before t0; clamp so it never shows "-1". */
          var p = Math.max(0, Math.min(1, (t - t0) / dur)), e = 1 - Math.pow(1 - p, 4);
          anim.textContent = stepped ? String(Math.min(target, Math.floor(p * (target + 1)))) : (target * e).toFixed(dec);
          if (p < 1) requestAnimationFrame(step);
          else { box.classList.remove('is-counting'); anim.remove(); }
        };
        requestAnimationFrame(step);
      }, { threshold: 0.6 });
      io.observe(el);
    });
  }
  /* ---------------- 2. Header shadow once the page scrolls ---------------- */
  function setupHeaderDepth() {
    var on = null, raf = 0;
    var upd = function () {
      raf = 0;
      var s = scrollY > 24;
      if (s !== on) { on = s; root.classList.toggle('fx-scrolled', s); }
    };
    window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(upd); }, { passive: true });
    upd();
  }

  /* ---------------- 3. Reading line ---------------- */
  function setupReadLine() {
    var cls = d.body.className;
    if (!/template-article|page-health|page-our-ulmo-honey|page-about-us/.test(cls)) return;
    var bar = d.getElementById('SiteHeaderInner');
    if (!bar) return;
    var line = d.createElement('span');
    line.className = 'fx-readline';
    line.setAttribute('aria-hidden', 'true');
    bar.appendChild(line);
    if (window.CSS && CSS.supports('animation-timeline: scroll()')) return;
    var raf = 0;
    var upd = function () {
      raf = 0;
      var h = root.scrollHeight - innerHeight;
      line.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, scrollY / h) : 0) + ')';
    };
    window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(upd); }, { passive: true });
    upd();
  }
  /* ---------------- 4. Origin film (Tony's drone footage, "edited DJI_0308.mov") ----------------
     1080p at about 7 Mbps on every screen (the sharpest version Shopify serves);
     720p only when the visitor's connection asks to save data or is slow.
     The script (captions and end line) lives in snippets/redesign-fx.liquid. */
  var FILM = {
    hd: 'https://cdn.shopify.com/videos/c/vp/c7dc3aad8335495f9e2b7179a9e36f92/c7dc3aad8335495f9e2b7179a9e36f92.HD-1080p-7.2Mbps-33308078.mp4',
    sd: 'https://cdn.shopify.com/videos/c/vp/c7dc3aad8335495f9e2b7179a9e36f92/c7dc3aad8335495f9e2b7179a9e36f92.HD-720p-4.5Mbps-33308078.mp4',
    poster: '/cdn/shop/files/preview_images/c7dc3aad8335495f9e2b7179a9e36f92.thumbnail.0000000000.jpg?width=1920',
    caps: (FX.film && FX.film.caps) || [],
    endLine: (FX.film && FX.film.endLine) || '',
    end: 36
  };
  var ICON_PAUSE = '<svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><rect x="3" y="2" width="3.5" height="12" rx="1"/><rect x="9.5" y="2" width="3.5" height="12" rx="1"/></svg>';
  var ICON_PLAY = '<svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M4 2.5v11a.5.5 0 0 0 .77.42l8.5-5.5a.5.5 0 0 0 0-.84l-8.5-5.5A.5.5 0 0 0 4 2.5z"/></svg>';
  function setupFilm() {
    if (FX.page !== 'index' || !FILM.caps.length) return;
    /* Below the featured-jar row (Tony, Oct 15); if that section is ever removed, after "Why Ulmo?". */
    var anchor = d.querySelector('.shopify-section[id*="__featured_product"]') || d.querySelector('[id$="__bento_main"]');
    if (!anchor || d.querySelector('.fx-film')) return;
    var caps = FILM.caps.map(function (c, i) {
      return '<p class="fx-film__cap" data-i="' + i + '"><span class="fx-film__k">' + esc(c[2]) + '</span>' + esc(c[3]) + '</p>';
    }).join('');
    var sec = d.createElement('section');
    sec.className = 'fx-film';
    sec.setAttribute('aria-label', 'Where Ulmo Honey comes from');
    sec.innerHTML = '<div class="fx-film__frame" style="background-image:url(' + FILM.poster + ')">' +
      '<video class="fx-film__video" muted playsinline preload="none" poster="' + FILM.poster + '" aria-hidden="true"></video>' +
      '<span class="fx-film__shade"></span>' +
      '<p class="fx-film__credit">The origin</p>' +
      '<div class="fx-film__caps">' + caps + '</div>' +
      '<div class="fx-film__end">' + (FILM.endLine ? '<p>' + esc(FILM.endLine) + '</p>' : '') +
      '<a class="fx-film__cta" href="/products/ulmo-honey">Shop Ulmo Honey</a>' +
      '<button type="button" class="fx-film__replay">Watch again</button></div>' +
      '<button type="button" class="fx-film__toggle" aria-label="Pause film">' + ICON_PAUSE + '</button>' +
      '</div>';
    anchor.insertAdjacentElement('afterend', sec);
    var v = sec.querySelector('video');
    var capEls = sec.querySelectorAll('.fx-film__cap');
    var toggle = sec.querySelector('.fx-film__toggle');
    var loaded = false, userPaused = false, ended = false, current = -1;
    var setCap = function (i) {
      if (i === current) return;
      current = i;
      capEls.forEach(function (el, k) { el.classList.toggle('is-on', k === i); });
    };
    var load = function () {
      if (loaded) return;
      loaded = true;
      var c = navigator.connection;
      v.src = c && (c.saveData || /2g|3g/.test(c.effectiveType || '')) ? FILM.sd : FILM.hd;
    };
    var setToggle = function (playing) {
      toggle.innerHTML = playing ? ICON_PAUSE : ICON_PLAY;
      toggle.setAttribute('aria-label', playing ? 'Pause film' : 'Play film');
    };
    var finish = function () {
      if (ended) return;
      ended = true;
      v.pause();
      setCap(-1);
      sec.classList.add('is-ended');
      setToggle(false);
    };
    var play = function () {
      load();
      var p = v.play();
      if (p && p.catch) p.catch(function () { setToggle(false); });
    };
    v.addEventListener('play', function () { setToggle(true); });
    v.addEventListener('pause', function () { if (!ended) setToggle(false); });
    v.addEventListener('timeupdate', function () {
      var t = v.currentTime, idx = -1;
      if (t >= FILM.end) { finish(); return; }
      for (var i = 0; i < FILM.caps.length; i++) if (t >= FILM.caps[i][0] && t < FILM.caps[i][1]) idx = i;
      setCap(idx);
    });
    v.addEventListener('ended', finish);
    sec.querySelector('.fx-film__replay').addEventListener('click', function () {
      ended = false; userPaused = false;
      sec.classList.remove('is-ended');
      v.currentTime = 0;
      play();
    });
    toggle.addEventListener('click', function () {
      if (ended) { sec.querySelector('.fx-film__replay').click(); return; }
      if (v.paused) { userPaused = false; play(); } else { userPaused = true; v.pause(); }
    });
    setCap(0);
    if (RM) { setToggle(false); return; }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var en = es[0];
        if (en.isIntersecting && en.intersectionRatio > 0.15) load();
        if (en.intersectionRatio >= 0.5 && !userPaused && !ended) play();
        else if (en.intersectionRatio < 0.2 && !v.paused) v.pause();
      }, { threshold: [0, 0.15, 0.2, 0.5], rootMargin: '25% 0px 25% 0px' }).observe(sec);
    }
  }

  /* ---------------- 5. Add-to-cart moment ---------------- */
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function sizedImage(url, w) {
    if (!url) return '';
    try {
      var u = new URL(url, location.href);
      u.searchParams.set('width', String(w));
      return u.href;
    } catch (_) { return url; }
  }
  /* The photo the shopper is looking at, but only when it's the jar. Any other photo
     (the comparison chart, lifestyle shots) means no flight, just the bag pop and toast. */
  function visibleJar() {
    var sel = ['.u-pdp-coverflow .swiper-slide-active img', '#SlidesCon .product-media-image img',
      '.u-featured-slideshow .swiper-slide-active img', '.featured-product--image img'];
    for (var i = 0; i < sel.length; i++) {
      var list = d.querySelectorAll(sel[i]);
      for (var k = 0; k < list.length; k++) {
        if (inView(list[k], 0.3)) return JAR_RE.test(list[k].currentSrc || list[k].src) ? list[k] : null;
      }
    }
    return null;
  }
  function fly(fromRect, src, target) {
    var b = target.getBoundingClientRect();
    var size = Math.max(64, Math.min(fromRect.width, fromRect.height, 240));
    var sx = fromRect.left + fromRect.width / 2, sy = fromRect.top + fromRect.height / 2;
    var ex = b.left + b.width / 2, ey = b.top + b.height / 2;
    var outer = d.createElement('div');
    outer.className = 'fx-fly';
    outer.style.cssText = 'width:' + size + 'px;height:' + size + 'px;left:' + (sx - size / 2) + 'px;top:' + (sy - size / 2) + 'px';
    var inner = d.createElement('div');
    inner.className = 'fx-fly__inner';
    var im = new Image();
    im.alt = '';
    im.src = src;
    inner.appendChild(im);
    outer.appendChild(inner);
    d.body.appendChild(outer);
    var dx = ex - sx, dy = ey - sy, dur = 860;
    var lift = Math.min(dy, 0) - Math.max(60, Math.abs(dx) * 0.12);
    outer.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(' + dx + 'px)' }],
      { duration: dur, easing: 'cubic-bezier(.25,.1,.25,1)', fill: 'forwards' });
    var y = inner.animate([
      { transform: 'translateY(0) scale(1) rotate(0deg)', opacity: 1, easing: 'cubic-bezier(.2,.7,.35,1)' },
      { transform: 'translateY(' + lift + 'px) scale(.42) rotate(-8deg)', opacity: 1, offset: 0.62, easing: 'cubic-bezier(.6,0,.9,.5)' },
      { transform: 'translateY(' + dy + 'px) scale(.06) rotate(-14deg)', opacity: 0.15 }
    ], { duration: dur, fill: 'forwards' });
    return y.finished.then(function () { outer.remove(); }, function () { outer.remove(); });
  }
  function bagPop(count) {
    var link = d.getElementById('cart-link');
    if (link) {
      link.classList.remove('fx-bag-pop');
      void link.offsetWidth;
      link.classList.add('fx-bag-pop');
      setTimeout(function () { link.classList.remove('fx-bag-pop'); }, 800);
    }
    var numb = d.querySelector('#cart-icon-bubble .hdr-cart-count-numb');
    var bubble = d.getElementById('cart-icon-bubble');
    if (numb && typeof count === 'number') numb.textContent = String(count);
    if (bubble) {
      bubble.classList.remove('fx-count-pop');
      void bubble.offsetWidth;
      bubble.classList.add('fx-count-pop');
    }
  }
  /* Free-shipping offer in the toast. It mirrors Settings → Shipping and delivery → Domestic:
     U.S. orders under $79 pay $4.95 for "Expedited (1 to 2 business days)", and $79+ after
     discounts ship free. Both amounts come from snippets/redesign-fx.liquid (freeShip, shipCost),
     so change them there if the rates change. ULMO+ members already ship free (member discount),
     so they get a short member line instead of the offer. */
  var NEED = FX.freeShip || 7900;
  var SHIP = FX.shipCost || 495;
  var NEED_TXT = money(NEED).replace('.00', '');
  var FINE = '*Free Expedited shipping (1–2 business days) on U.S. orders of ' + NEED_TXT + '+ after discounts.';
  var ICON_CHECK = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3.6 8.4l2.9 2.9 5.9-6.6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_PLUS = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M8 3.2v9.6M3.2 8h9.6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';
  var liveRegion = null, closeToast = null, countryReq = null;

  function getCart() {
    return fetch('/cart.js?fx=' + Date.now(), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  /* Where the shopper is, from Shopify's own IP lookup. The storefront country stays "US" for
     visitors abroad until they pick a country, so this keeps the U.S.-only offer away from them.
     Cached for the visit; after 1.2 s it gives up and the toast trusts the storefront country. */
  function visitorCountry() {
    if (countryReq) return countryReq;
    var hit = null;
    try { hit = sessionStorage.getItem('ulmo-fx-country'); } catch (_) {}
    if (hit) return (countryReq = Promise.resolve(hit));
    var req = fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var c = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
        if (c) { try { sessionStorage.setItem('ulmo-fx-country', c); } catch (_) {} }
        return c || null;
      })
      .catch(function () { return null; });
    countryReq = Promise.race([req, new Promise(function (res) { setTimeout(function () { res(null); }, 1200); })]);
    return countryReq;
  }
  /* Which shipping message the toast shows. */
  function shipState(item, cart, ip) {
    var store = String(FX.country || (window.Shopify && window.Shopify.country) || '').toUpperCase();
    if (store !== 'US' || (ip && ip !== 'US') || (cart && cart.currency && cart.currency !== 'USD')) return { kind: 'intl' };
    if (FX.member) return { kind: 'member' };
    if (!cart) return { kind: 'rule' };
    var total = cart.total_price;
    if (total >= NEED) return { kind: 'free' };
    var plan = item && item.selling_plan_allocation;
    var unit = !item ? 0 : plan ? (plan.compare_at_price || item.original_price || 0)
      : (item.final_price != null ? item.final_price : item.price) || 0;
    /* A cart-level code (e.g. 20% off) also lowers what the 2nd jar adds toward $79. */
    var ratio = cart.items_subtotal_price > 0 ? Math.min(1, total / cart.items_subtotal_price) : 1;
    /* Regular price, shown crossed out when a code in the bag already lowers it (e.g. 20% off). */
    var was = !item || plan ? 0 : item.original_price || 0;
    if (unit > 0 && total + unit * ratio >= NEED) return { kind: 'jar', unit: unit, was: was > unit ? was : 0, single: cart.item_count === 1 };
    return { kind: 'away', left: NEED - total, pct: Math.max(0, total) / NEED };
  }
  /* Mini Ulmo jar: the black jar's wide domed lid and rounded body, with the gold coil mark
     (four rings traced from logo_tight_bounding_box.png). The empty slot is a dashed outline;
     the full jar drops into it when the 2nd jar is added. */
  var COIL = '<ellipse cx="12.02" cy="4.73" rx="8.84" ry="4.54"/><ellipse cx="12.02" cy="8.38" rx="10.33" ry="5.30"/>' +
    '<ellipse cx="12.02" cy="12.38" rx="11.26" ry="5.89"/><ellipse cx="12.02" cy="17.02" rx="11.82" ry="6.09"/>';
  var jarSeq = 0;
  function jarIcon(full) {
    var g = 'fx-coil-' + (++jarSeq);
    return '<span class="fx-jar' + (full ? ' is-full' : '') + '">' +
      '<span class="fx-jar__ghost"><span class="fx-jar__cap"></span><span class="fx-jar__body"></span></span>' +
      '<span class="fx-jar__real"><span class="fx-jar__cap"></span><span class="fx-jar__body">' +
      '<svg class="fx-jar__logo" viewBox="0 0 24 23.34" aria-hidden="true" focusable="false"><defs><linearGradient id="' + g + '" x1="0" y1="0" x2="1" y2="0">' +
      '<stop offset="0" stop-color="#f1d77e"/><stop offset=".55" stop-color="#d9ae4f"/><stop offset="1" stop-color="#8a6a2a" stop-opacity=".35"/></linearGradient></defs>' +
      '<g fill="none" stroke="url(#' + g + ')" stroke-width="1.35">' + COIL + '</g></svg></span></span></span>';
  }
  function tick(text) {
    return '<p class="fx-offer__head fx-offer__head--tick"><span class="fx-offer__tick">' + ICON_CHECK + '</span><span>' + text + '</span></p>';
  }
  function offerHTML(s) {
    switch (s.kind) {
      case 'intl': return '<p class="fx-toast__note">Shipping is calculated at checkout.</p>';
      case 'rule': return '<p class="fx-toast__note">Free expedited shipping on U.S. orders of ' + NEED_TXT + '+.</p>';
      case 'member': return '<div class="fx-offer is-done">' + tick('Free expedited shipping') +
        '<p class="fx-offer__why">Included with your ULMO+ membership.</p></div>';
      case 'free': return '<div class="fx-offer is-done">' + tick('Free expedited shipping unlocked') + '</div>';
      case 'away': return '<div class="fx-offer"><p class="fx-offer__head">You’re ' + money(s.left) +
        ' away from free expedited shipping*</p><div class="fx-toast__bar" aria-hidden="true"><i data-pct="' + s.pct.toFixed(3) + '"></i></div></div>';
    }
    return '<div class="fx-offer">' +
      (s.single ? '<div class="fx-offer__jars" aria-hidden="true">' + jarIcon(true) + jarIcon(false) +
        '<span class="fx-offer__count">1 of 2 jars</span></div>' : '') +
      '<p class="fx-offer__head">Add one more jar for free expedited shipping*</p>' +
      '<p class="fx-offer__why">Skip the ' + money(SHIP) + ' shipping fee. Keep one, gift one.</p>' +
      '<button type="button" class="fx-offer__add">' + ICON_PLUS + '<span class="fx-offer__label">Add a 2nd jar · ' +
        (s.was ? '<s class="fx-offer__was"><span class="fx-sr">was </span>' + money(s.was) + '</s> ' : '') + money(s.unit) + '</span></button>' +
      '<p class="fx-offer__err" hidden></p></div>';
  }
  function announce(text) {
    if (!liveRegion) {
      liveRegion = d.createElement('span');
      liveRegion.className = 'fx-sr';
      liveRegion.setAttribute('role', 'status');
      d.body.appendChild(liveRegion);
    }
    liveRegion.textContent = '';
    setTimeout(function () { liveRegion.textContent = text; }, 60);
  }
  /* Lets the theme refresh anything else that shows the cart (e.g. the product page's "in cart" note). */
  function tellTheme(cart) {
    try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ulmo-fx', cartData: cart }); } catch (_) {}
  }
  /* Shopify custom events, so a custom pixel can count offer views against 2nd-jar adds. */
  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data || {}); } catch (_) {}
  }
  /* Offer tracker (Oct 20, 2026). Saves what happened with the 2nd-jar offer on the cart, so every
     order shows it in Shopify admin (Orders → the order → Additional details → "Free-shipping offer"):
     "Shown" = the offer appeared, "Added 2nd jar" = the shopper used its button.
     Cart writes from this file wait in one queue, so the note never races an add to cart. */
  var OFFER_KEY = 'Free-shipping offer';
  var OFFER_ADDED = 'Added 2nd jar';
  var cartQueue = Promise.resolve();
  function queueCart(fn) {
    var next = cartQueue.then(fn, fn);
    cartQueue = next.catch(function () {});
    return next;
  }
  function noteOffer(value) {
    var attrs = {};
    attrs[OFFER_KEY] = value;
    queueCart(function () {
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ attributes: attrs })
      });
    });
  }
  /* Runs fn, then eases the toast from its old height to the new one. */
  function morph(el, fn) {
    var h0 = el.offsetHeight;
    fn();
    var h1 = el.offsetHeight;
    if (RM || !el.animate || Math.abs(h1 - h0) < 2) return;
    el.style.overflow = 'hidden';
    var a = el.animate([{ height: h0 + 'px' }, { height: h1 + 'px' }], { duration: 380, easing: 'cubic-bezier(.2,.8,.2,1)' });
    a.onfinish = a.oncancel = function () { el.style.overflow = ''; };
  }
  /* Before the 2nd-jar button disappears, hand keyboard focus to Checkout so it isn't lost. */
  function keepFocus(el, node) {
    if (node && node.contains(d.activeElement)) {
      var next = el.querySelector('.fx-toast__btn--primary');
      if (next) next.focus();
    }
  }
  function markDone(el) {
    var panel = el.querySelector('.fx-offer');
    if (!panel) return;
    keepFocus(el, panel);
    var jars = panel.querySelectorAll('.fx-jar');
    if (jars[1]) jars[1].classList.add('is-full');
    var count = panel.querySelector('.fx-offer__count');
    if (count) count.textContent = '2 of 2 jars';
    panel.querySelector('.fx-offer__head').outerHTML = tick('Free expedited shipping unlocked');
    panel.querySelector('.fx-offer__why').textContent = 'You just saved ' + money(SHIP) + ' on shipping.';
    ['.fx-offer__add', '.fx-offer__err'].forEach(function (s) { var x = panel.querySelector(s); if (x) x.remove(); });
    var fine = el.querySelector('.fx-toast__fine');
    if (fine) fine.remove();
    panel.classList.add('is-done');
  }
  function addSecondJar(item, el, btn, ctl) {
    if (btn.getAttribute('aria-disabled') === 'true') return;
    var label = btn.querySelector('.fx-offer__label');
    var orig = label.innerHTML;
    var err = el.querySelector('.fx-offer__err');
    /* aria-disabled rather than disabled: a disabled button drops keyboard focus */
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('is-busy');
    label.textContent = 'Adding…';
    if (err) err.hidden = true;
    ctl.hold(true);
    var variant = item.variant_id || item.id;
    var line = { id: variant, quantity: 1 };
    /* Joins the first jar's line. If that jar is a subscription, the 2nd jar is a one-time purchase. */
    if (!item.selling_plan_allocation && item.properties && typeof item.properties === 'object' && Object.keys(item.properties).length) line.properties = item.properties;
    var added = false;
    var finish = function (cart) {
      ctl.hold(false);
      bagPop(cart ? cart.item_count : undefined);
      if (cart) tellTheme(cart);
      var n = 0;
      if (cart) (cart.items || []).forEach(function (l) { if (l.variant_id === variant) n += l.quantity; });
      var qty = el.querySelector('.fx-toast__qty');
      if (qty && n > 1) qty.textContent = ' × ' + n;
      /* No cart read-back: the offer was only shown because one more jar reaches $79. */
      if (!cart || cart.total_price >= NEED) {
        morph(el, function () { markDone(el); });
        announce('Second jar added. Free expedited shipping unlocked.');
      } else {
        morph(el, function () {
          var panel = el.querySelector('.fx-offer');
          keepFocus(el, panel);
          panel.innerHTML = '<p class="fx-offer__head">You’re ' + money(NEED - cart.total_price) + ' away from free expedited shipping*</p>';
        });
        announce('Second jar added.');
      }
      ctl.arm(10000);
      track('ulmo_second_jar_added', { cart_total: cart ? cart.total_price / 100 : null });
      noteOffer(OFFER_ADDED);
    };
    queueCart(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [line] })
      });
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok || j.status) throw j; return j; });
      })
      .then(function () { added = true; return getCart(); })
      .then(finish)
      .catch(function (e) {
        ctl.hold(false);
        if (added) { /* the jar is in the bag; only the display update failed */
          try { finish(null); } catch (_) { btn.remove(); ctl.arm(10000); }
          return;
        }
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('is-busy');
        label.innerHTML = orig;
        var msg = e && typeof e.description === 'string' && e.description ? e.description : 'Couldn’t add another jar. Please try again.';
        if (err) { err.textContent = msg; err.hidden = false; }
        announce(msg);
        ctl.arm();
      });
  }
  function showToast(item, cart, ip) {
    if (closeToast) closeToast(true);
    var s = shipState(item, cart, ip);
    /* Keyboard shoppers get focus moved into the toast, and back to the button they pressed when it closes. */
    var opener = d.activeElement, keys = false;
    try { keys = !!(opener && opener !== d.body && opener.matches(':focus-visible')); } catch (_) {}
    var imgUrl = item && (item.featured_image && item.featured_image.url || item.image);
    var title = item && (item.product_title || item.title) || 'Ulmo Honey';
    var qty = item && item.quantity > 1 ? ' × ' + item.quantity : '';
    var el = d.createElement('div');
    el.className = 'fx-toast fx-toast--' + s.kind;
    el.setAttribute('role', 'region');
    el.setAttribute('aria-label', 'Added to your bag');
    el.innerHTML = '<button type="button" class="fx-toast__close" aria-label="Close">×</button>' +
      '<div class="fx-toast__row">' + (imgUrl ? '<img class="fx-toast__thumb" alt="" src="' + esc(sizedImage(imgUrl, 160)) + '">' : '') +
      '<div><p class="fx-toast__title"><span class="fx-toast__ok">' + ICON_CHECK + '</span>Added to your bag</p>' +
      '<p class="fx-toast__sub">' + esc(title) + '<span class="fx-toast__qty">' + esc(qty) + '</span></p></div></div>' +
      offerHTML(s) +
      '<div class="fx-toast__actions"><a class="fx-toast__btn fx-toast__btn--ghost" href="/cart">View bag</a>' +
      '<a class="fx-toast__btn fx-toast__btn--primary" href="/checkout">Checkout</a></div>' +
      (s.kind === 'jar' || s.kind === 'away' ? '<p class="fx-toast__fine">' + esc(FINE) + '</p>' : '');
    d.body.appendChild(el);
    /* Stays 15 s (10 s after a 2nd jar), and never closes while the shopper is touching, hovering or tabbing through it. */
    var timer = null, wait = 15000, hover = false, focus = false, held = false, gone = false;
    var close = function (now) {
      if (gone) return;
      gone = true;
      clearTimeout(timer);
      d.removeEventListener('keydown', onKey);
      if (closeToast === close) closeToast = null;
      if (now === true) { el.remove(); return; }
      if (el.contains(d.activeElement) && opener && opener.focus) { try { opener.focus(); } catch (_) {} }
      el.classList.remove('is-open');
      setTimeout(function () { el.remove(); }, 450);
    };
    var arm = function (ms) {
      if (ms) wait = ms;
      clearTimeout(timer);
      if (!hover && !focus && !held) timer = setTimeout(close, wait);
    };
    var onKey = function (e) { if (e.key === 'Escape' || e.key === 'Esc') close(); };
    closeToast = close;
    el.querySelector('.fx-toast__close').addEventListener('click', function () { close(); });
    el.addEventListener('pointerenter', function () { hover = true; clearTimeout(timer); });
    el.addEventListener('pointerdown', function () { clearTimeout(timer); });
    el.addEventListener('pointerleave', function () { hover = false; arm(); });
    el.addEventListener('focusin', function (e) {
      var viaKeys = true;
      try { viaKeys = e.target.matches(':focus-visible'); } catch (_) {}
      if (viaKeys) { focus = true; clearTimeout(timer); }
    });
    el.addEventListener('focusout', function (e) { if (!el.contains(e.relatedTarget)) { focus = false; arm(); } });
    d.addEventListener('keydown', onKey);
    var ctl = { arm: arm, hold: function (on) { held = on; if (on) clearTimeout(timer); } };
    var add = el.querySelector('.fx-offer__add');
    if (add) add.addEventListener('click', function () { addSecondJar(item, el, add, ctl); });
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.classList.add('is-open');
        var bar = el.querySelector('.fx-toast__bar i');
        if (bar) bar.style.transform = 'scaleX(' + bar.getAttribute('data-pct') + ')';
        if (keys) (el.querySelector('.fx-offer__add') || el.querySelector('.fx-toast__btn--primary')).focus();
      });
    });
    arm();
    announce('Added to your bag. ' + (s.kind === 'jar' ? 'Add one more jar for free expedited shipping.'
      : s.kind === 'free' ? 'Free expedited shipping unlocked.'
      : s.kind === 'away' ? 'You’re ' + money(s.left) + ' away from free expedited shipping.' : ''));
    if (s.kind === 'jar') {
      track('ulmo_second_jar_offer_shown', { cart_total: cart.total_price / 100 });
      if (!(cart.attributes && cart.attributes[OFFER_KEY] === OFFER_ADDED)) noteOffer('Shown');
    }
  }
  function cartMoment(item) {
    var img = RM ? null : visibleJar();
    var target = d.querySelector('#cart-link .icon-bag') || d.getElementById('cart-link');
    var flight = img && target ? fly(img.getBoundingClientRect(), flySrc(img), target) : Promise.resolve();
    Promise.all([flight, getCart(), visitorCountry()]).then(function (res) {
      var cart = res[1];
      bagPop(cart ? cart.item_count : undefined);
      showToast(item, cart, res[2]);
    }).catch(function (err) { if (window.console) console.warn('[ulmo-fx] toast skipped:', err && err.message); });
  }
  function setupCartMoment() {
    if (d.querySelector('cart-drawer, cart-notification') || !d.querySelector('product-form')) return;
    var stub = d.createElement('div');
    stub.className = 'fx-cart-stub';
    stub.hidden = true;
    stub.getSectionsToRender = function () { return []; };
    /* The product form calls this just before it adds to the bag: start the country lookup then. */
    stub.setActiveElement = function () { visitorCountry(); };
    stub.renderContents = function (res) { cartMoment(res && res.items ? res.items[0] : res); };
    d.body.appendChild(stub);
    /* Warm the flight PNGs so the first add to cart never flies an empty frame. */
    if (!RM) [FLY_PNG.front, FLY_PNG.back].forEach(function (u) { var p = new Image(); p.src = u; });
    announce('');
    var patch = function () {
      d.querySelectorAll('product-form').forEach(function (pf) { if (!pf.cart) pf.cart = stub; });
    };
    if (window.customElements) customElements.whenDefined('product-form').then(patch);
  }

  /* ---------------- boot ---------------- */
  function safe(name, fn) {
    try { fn(); } catch (err) { if (window.console) console.warn('[ulmo-fx] ' + name + ' skipped:', err && err.message); }
  }
  ready(function () {
    safe('counters', setupCounters);
    safe('header shadow', setupHeaderDepth);
    safe('reading line', setupReadLine);
    safe('film', setupFilm);
    safe('cart moment', setupCartMoment);
  });
})();
